(function () {
    const initBasketCounters = () => {
        const safeCount = (obj) => (obj && typeof obj === 'object' ? Object.keys(obj).length : 0);

        const setText = (id, value) => {
            const el = document.getElementById(id);
            if (el) {
                el.textContent = String(value);
            }
        };

        const refreshBasketCounters = () => {
            const siteDir = window.arNextOptions && window.arNextOptions.SITE_DIR ? window.arNextOptions.SITE_DIR : '/';
            const url = siteDir.replace(/\/?$/, '/') + 'ajax/getAjaxBasket.php';

            fetch(url, {
                method: 'GET',
                credentials: 'same-origin',
                headers: {'X-Requested-With': 'XMLHttpRequest'},
            })
                .then((res) => {
                    if (!res.ok) throw new Error(`HTTP ${res.status}`);
                    return res.json();
                })
                .then((data) => {
                    setText('mobile-menu-basket-count', safeCount(data.BASKET));
                    setText('header-mobile-basket-count', safeCount(data.BASKET));
                    setText('mobile-menu-delay-count', safeCount(data.DELAY));
                    setText('mobile-menu-compare-count', safeCount(data.COMPARE));
                })
                .catch((e) => {
                    console.error('Ошибка обновления корзины:', e);
                });
        };

        refreshBasketCounters();

        if (window.BX && typeof window.BX.addCustomEvent === 'function') {
            window.BX.addCustomEvent('onCompleteAction', (eventData) => {
                if (!eventData || !eventData.action) return;
                // Если событие связано с корзиной - обновляем цифры
                if (String(eventData.action).indexOf('loadBasket') === 0) {
                    refreshBasketCounters();
                }
            });
        }
    };

    const startCounters = () => {
        if (typeof window.BX !== 'undefined' && typeof window.BX.ready === 'function') {
            window.BX.ready(initBasketCounters);
        } else {
            initBasketCounters();
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startCounters);
    } else {
        startCounters();
    }
})();
